export class SmtpConfigModel {
  public id: number;
  public smtpName: string;
  public port: number;
  public password?: string;
  public emailSender: string;
  public source: string;

  constructor() {
    this.id = 0;
    this.smtpName = "";
    this.port = 0;
    this.password = undefined;
    this.emailSender = "";
    this.source = "";
  }
}

export class EmailReceiverModel {
  constructor(public id: number, public emailAddress: string) {}
}

export class EmailConfigurationModel {
  public smtpConfig: SmtpConfigModel = new SmtpConfigModel();
  public emailReceivers: Array<EmailReceiverModel> = new Array<EmailReceiverModel>();
}
